import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/pages/index/index.vue';
import Home from '@/pages/index/home/index.vue';
import Info from '@/pages/index/info/index.vue';
import Role from '@/pages/index/role/index.vue';

import Players from '@/pages/index/players/index.vue';
import PlayerInfo from '@/pages/index/players/info.vue';
import OrgPlayerInfo from '@/pages/index/players/org.vue';

import Games from '@/pages/index/games/index.vue';
import GameInfo from '@/pages/index/games/info.vue';
import Results from '@/pages/index/games/results.vue';

import FilesDownload from '@/pages/index/filesDownload/index.vue';

import NewsList from '@/pages/news/newsList.vue';
import News from '@/pages/news/index.vue';

import Login from '@/pages/login/index.vue';
import Registry from '@/pages/registry/index.vue';
import ChangePwd from '@/pages/changePwd/index.vue';

import OrganizationApprove from '@/pages/organizationApprove/index.vue';
import UserInfoApprove from '@/pages/userInfoApprove/index.vue';

import { getStorage } from '@/utils/storageUtils.js';

Vue.use(Router);

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

const VueRouterReplace = Router.prototype.replace;
Router.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => err);
};

let router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savePosition) {
    // 在点击浏览器的“前进/后退”，或者切换导航的时候触发。
    if (savePosition) {
      return savePosition;
    } else {
      var top;
      if (window.innerWidth >= 700) {
        top = 676;
      } else {
        top = 267;
      }
      return {
        x: 0,
        y: top,
      };
    }
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [
        {
          path: '/',
          name: 'home',
          component: Home,
        },
        {
          path: '/info',
          name: 'info',
          component: Info,
        },
        {
          path: '/role',
          name: 'role',
          component: Role,
        },
        {
          path: '/players',
          name: 'players',
          component: Players,
        },
        {
          path: '/playerinfo',
          name: 'playerInfo',
          component: PlayerInfo,
        },
        {
          path: '/orgPlayerInfo',
          name: 'orgPlayerInfo',
          component: OrgPlayerInfo,
        },
        {
          path: '/games',
          name: 'games',
          component: Games,
        },
        {
          path: '/gameinfo',
          name: 'gameInfo',
          component: GameInfo,
        },
        {
          path: '/results',
          name: 'results',
          component: Results,
        },
        {
          path: '/filesdownload',
          name: 'filesDownload',
          component: FilesDownload,
        },
        {
          path: '/newslist',
          name: 'newsList',
          component: NewsList,
        },
        {
          path: '/news',
          name: 'news',
          component: News,
        },
        {
          path: '/login',
          name: 'login',
          component: Login,
        },
        {
          path: '/registry',
          name: 'registry',
          component: Registry,
        },
        {
          path: '/changepwd',
          name: 'changePwd',
          component: ChangePwd,
        },
        {
          path: '/organizationapprove',
          name: 'organizationApprove',
          component: OrganizationApprove,
        },
        {
          path: '/userinfoapprove',
          name: 'userInfoApprove',
          component: UserInfoApprove,
        },
      ],
    },
  ],
});

const loginNeedList = [
  'info',
  'changepwd',
  'organizationapprove',
  'userinfoapprove',
];

// 强制登录
router.beforeEach(function(to, from, next) {
  let token = getStorage('token');
  if (loginNeedList.indexOf(to.name) >= 0 && !token) {
    router.replace({
      name: 'login',
      query: {
        fullPath: to.fullPath,
      },
    });
  } else {
    next();
  }
});

router.afterEach((to, from, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  window.scrollTo(0, 0);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js